import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Spinner } from "@phosphor-icons/react";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { googleSession } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/login", { replace: true }); return; }
    googleSession(decodeURIComponent(match[1])).then((res) => {
      if (res.ok) {
        toast.success("Berhasil masuk dengan Google");
        window.history.replaceState(null, "", window.location.pathname);
        navigate(res.user.role === "admin" ? "/admin" : "/", { replace: true });
      } else {
        toast.error(res.error || "Login Google gagal");
        navigate("/login", { replace: true });
      }
    });
  }, [googleSession, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background">
      <Spinner size={44} className="text-primary animate-spin mb-4" />
      <p className="text-zinc-400">Menyelesaikan proses masuk...</p>
    </div>
  );
}
